import { Card, CardBody, Col, Row } from "reactstrap";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { useWeb3React } from "@web3-react/core";
// import { ethers } from "ethers";
import { getMintTierAttributes } from "../../../redux/mintTiers";
import { genericAbiRead } from "../../../redux/contracts";
import MintButtons from "./utils/MintButtons";
import { REACT_APP_ARCTIC_DISCOUNT_TIER } from "../../../utils/env";
// import TrunkatedAddress from "../../Utils/TrunkatedAddress";

const MintPassCard = ({ mintTierId, whitelistId, address }, context) => {
  const dispatch = useDispatch();
  const isDiscountTier = mintTierId === REACT_APP_ARCTIC_DISCOUNT_TIER;
  const { account, provider } = useWeb3React();

  const [mintPrice, setMintPrice] = useState(null);
  const [usdMintPrice, setUsdMintPrice] = useState(null);
  const [mintEnabled, setMintEnabled] = useState(false);
  const [availableAmount, setAvailableAmount] = useState(0);
  const [alreadyMintedAmount, setAlreadyMintedAmount] = useState(0);

  const mintTier = useSelector((state) =>
    getMintTierAttributes(state, mintTierId)
  );

  const getMintEnabled = async () => {
    if (!mintTier?.enabled_abi?.name) return true;
    dispatch(
      genericAbiRead({
        functionAbi: mintTier?.enabled_abi,
        contractAddress: mintTier?.contract_address,
        account: account,
        provider: provider,
        successCallbackFnc: (data) => {
          setMintEnabled(data);
          // dispatch(mintingInProgressSuccess());
        },
        errorCallbackFnc: (data) => {
          // alert("Error on Mint Price");
          // alert(data);
          // dispatch(mintError(data));
          console.log("mint enabled error", data);
        },
      })
    );
  };

  const getAvailableAmount = async () => {
    if (!mintTier?.available_amount_abi?.name) return true;
    dispatch(
      genericAbiRead({
        functionAbi: mintTier?.available_amount_abi,
        contractAddress: mintTier?.contract_address,
        account: account,
        provider: provider,
        genericInputs: {
          key: account,
        },
        successCallbackFnc: (data) => {
          console.log("available amount", data);
          setAvailableAmount(
            parseInt(data?._isBigNumber ? data?.toString() : data)
          );
          // dispatch(mintingInProgressSuccess());
        },
        errorCallbackFnc: (data) => {
          // alert("Error on Available Mint Amount");
          // alert(data);
          console.log("available amount", data);
          // dispatch(mintError(data));
        },
      })
    );
  };

  const getAlreadyMintedAmount = async () => {
    if (!mintTier?.already_minted_amount_abi?.name) return true;
    dispatch(
      genericAbiRead({
        functionAbi: mintTier?.already_minted_amount_abi,
        contractAddress: mintTier?.contract_address,
        account: account,
        provider: provider,
        genericInputs: {
          key: account,
        },
        successCallbackFnc: (data) => {
          setAlreadyMintedAmount(
            parseInt(data?._isBigNumber ? data.toString() : data)
          );
          // dispatch(mintingInProgressSuccess());
        },
        errorCallbackFnc: (data) => {
          // alert("Error on Already Minted Amount");
          // alert(data);
          // dispatch(mintError(data));
          console.log("already minted", data);
        },
      })
    );
  };

  const getMintPrice = async () => {
    if (!mintTier?.price_abi?.name) return 0;
    dispatch(
      genericAbiRead({
        functionAbi: mintTier?.price_abi,
        contractAddress: mintTier?.contract_address,
        account: account,
        provider: provider,
        successCallbackFnc: (data) => {
          setMintPrice(data?._isBigNumber ? data.toString() : data);
          // dispatch(mintingInProgressSuccess());
        },
        errorCallbackFnc: (data) => {
          // alert("Error");
          // alert(data);
          // dispatch(mintError(data));
          console.log("mintPrice error", data);
        },
      })
    );
  };

  const fetchUSDPrice = async () => {
    const priceAbi = {
      inputs: [],
      name: isDiscountTier ? "discountMintUSDPrice" : "mintUSDPrice",
      outputs: [{ internalType: "int256", name: "", type: "int256" }],
      stateMutability: "view",
      type: "function",
    };

    dispatch(
      genericAbiRead({
        functionAbi: priceAbi,
        contractAddress: mintTier?.contract_address,
        account: account,
        provider: provider,
        functionName: isDiscountTier
          ? "discountMintUSDPrice()"
          : "mintUSDPrice()",
        successCallbackFnc: (data) => {
          setUsdMintPrice(data?._isBigNumber ? data.toString() : data);
        },
        errorCallbackFnc: (data) => {
          console.log("error usd price", data);
        },
      })
    );
  };

  useEffect(() => {
    getMintPrice();
    fetchUSDPrice();
    getAvailableAmount();
  }, []);

  useEffect(() => {
    getMintEnabled();
    getAlreadyMintedAmount();
    const interval = setInterval(() => {
      getMintEnabled();
      getAlreadyMintedAmount();
    }, 5000); //refresh every 5 seconds enabled and available amount
    return () => clearInterval(interval);
  }, []);

  return (
    <Row className="mb-5">
      <Col xs={12} lg={7} className="mb-5 mb-lg-0">
        <Card className="d-flex flex-column border rounded text-align-justify bg-transparent pb-lg-3 h-100">
          <CardBody className="p-5 mb-lg-5">
            <h1 className="text-dark mb-4">{mintTier?.title}</h1>
            <div>
              <hr />
            </div>
            <p className="mt-4 h4 small mb-3 text-muted">
              {context.t("Price/NFT")}
            </p>
            <p className="text-dark fw-bold mb-5">
              {parseFloat(usdMintPrice / 100000000)} USD
            </p>
            <div className="text-dark me-5 mb-5">
              {mintTier?.description && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: mintTier?.description.replace(
                      /href=/g,
                      "target='_blank' rel='noopener noreferrer' href="
                    ),
                  }}
                />
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col xs={12} lg={5} className="">
        <Card
          className="shadow border-0 h-100"
          // style={{ opacity: maxMintAmount() <= 0 ? "0.7" : "1.0" }}
        >
          <CardBody className="p-5 text-dark bg-white">
            <div className="text-center">
              <div className="my-4 px-3">
                <>
                  <p>
                    You are eligible to purchase {availableAmount}{" "}
                    {availableAmount === 1 ? "NFT" : "NFTs"}
                  </p>
                  <p className="font-weight-bold h2">
                    {alreadyMintedAmount}/{availableAmount}
                  </p>
                  <small>{context.t("Already purchased / wallet")}</small>
                </>
              </div>
              <MintButtons
                whitelistId={whitelistId}
                mintTierId={mintTierId}
                mintPrice={mintPrice}
                usdMintPrice={usdMintPrice}
                availableAmount={availableAmount}
                alreadyMintedAmount={alreadyMintedAmount}
                contractAddress={mintTier?.contract_address}
                showConceriergePayment={!isDiscountTier}
                disabled={
                  !mintEnabled ||
                  availableAmount <= 0 ||
                  availableAmount - alreadyMintedAmount <= 0
                }
                address={address}
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

/**  define proptype for the 'translation' function  */
MintPassCard.contextTypes = {
  t: PropTypes.func,
};

MintPassCard.propTypes = {
  whitelistId: PropTypes.number,
  mintTierId: PropTypes.string,
  address: PropTypes.string,
};

MintPassCard.defaultProps = {};

export default MintPassCard;
